<template>
    <i
        class="fa fa-lg pointer"
        :class="'fa-' + icon"
        @click="sendReminder"
        :title="uLang('app.send_invoice_reminder')"
    ></i>
</template>

<script>
import { ConfirmationAlert } from '~/Swals'

export default {
    name: 'SalesInvoiceReminderButton',

    props: {
        icon: {
            type: String,
            required: false,
            default: 'refresh',
        },
        invoiceId: {
            type: Number,
            required: false,
        },
        name: {
            type: String,
            default: '<geen naam>',
        }
    },

    methods: {
        sendReminder() {
            new ConfirmationAlert({
                entity: this.lang('app.sales_invoice_reminder'),
                text: this.uLang('app.confirm_reminder_entity', { entity: this.name }),
            }).show().then(async () => {
                const { data } = await window.axios.post(route('invoices.sales.reminder', { invoice: this.invoiceId }));

                if(data === 'success') {
                    this.$snotify.info(uLang('app.sales_invoice_reminder_sent'));
                }
            })
        }
    }
}
</script>

<style>

</style>